import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const pageFooterSlotRecipe = defineSlotRecipe({
  className: 'page-footer',
  slots: ['root', 'status', 'statusDot', 'statusLabel', 'copyright', 'copyrightText', 'links', 'link'] as const,
  base: {
    root: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: { base: 'column', tablet: 'row' },
      gap: { base: '16', tablet: '0' },
      justifyContent: 'space-between',
      padding: { base: '16', tablet: '0' },
      paddingInlineStart: { base: '16', tablet: '20' },
      width: '100%',
    },
    status: {
      alignItems: 'center',
      borderRadius: '4',
      display: 'flex',
      flexShrink: 0,
      gap: '4',
      paddingBlock: '4',
      paddingInlineEnd: '8',
      paddingInlineStart: '4',
    },
    statusDot: {
      borderRadius: 'full',
      flexShrink: 0,
      height: '8',
      width: '8',
      marginInline: '4',
    },
    statusLabel: {
      color: 'text/secondary',
      textStyle: 'comp/badge/sm',
      whiteSpace: 'nowrap',
    },
    copyright: {
      alignItems: 'center',
      display: 'flex',
      gap: '8',
      order: { base: 3, tablet: 0 },
    },
    copyrightText: {
      color: 'text/secondary',
      textStyle: 'body/md/regular',
      whiteSpace: 'nowrap',
    },
    links: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      flexWrap: { base: 'wrap', tablet: 'nowrap' },
      gap: { base: '40', tablet: '24' },
      justifyContent: { base: 'center', tablet: 'flex-start' },
      order: { base: 2, tablet: 0 },
      rowGap: { base: '12', tablet: '8' },
      width: { base: '100%', tablet: 'auto' },
    },
    link: {
      background: 'transparent',
      border: 'none',
      color: 'text/secondary',
      cursor: 'pointer',
      padding: 0,
      textDecoration: 'none',
      textStyle: { base: 'body/lg/regular', tablet: 'body/md/regular' },
      whiteSpace: 'nowrap',
      _hover: {
        textDecoration: 'underline',
      },
    },
  },
  variants: {
    colorVariant: {
      gray: {
        root: {
          background: 'background/secondary',
        },
        status: {
          background: 'background/tertiary',
        },
      },
      white: {
        root: {
          background: 'background/primary',
        },
        status: {
          background: 'background/secondary',
        },
      },
    },
    size: {
      compact: {
        root: {
          height: { tablet: '32' },
        },
      },
      default: {
        root: {
          height: { tablet: '64' },
        },
      },
    },
    variant: {
      default: {
        root: {
          paddingInlineEnd: { base: '16', tablet: rem(80) },
          position: { tablet: 'relative' },
        },
        copyright: {
          insetInlineStart: { tablet: '50%' },
          position: { tablet: 'absolute' },
          top: { tablet: '50%' },
          transform: { tablet: 'translate(-50%, -50%)' },
        },
        links: {
          borderBlockEnd: { base: '1px solid', tablet: 'none' },
          borderBlockStart: { base: '1px solid', tablet: 'none' },
          borderColor: 'border/minimal',
          paddingBlock: { base: '16', tablet: '0' },
        },
      },
      public: {
        root: {
          paddingInlineEnd: { base: '16', tablet: '40' },
        },
        links: {
          borderBlockEnd: { base: '1px solid', tablet: 'none' },
          borderColor: 'border/minimal',
          paddingBlockEnd: { base: '16', tablet: '0' },
        },
      },
    },
  },
  defaultVariants: {
    colorVariant: 'gray',
    size: 'default',
    variant: 'default',
  },
});

export default pageFooterSlotRecipe;
